import cloneDeep from 'lodash.clonedeep';
import handleRequest from '../../../utils/handleRequest';
import initialState from '..'; // -------------------------------------------------
// CONSTANTS
// -------------------------------------------------

export var GET_USER_DETAILS = 'GET_USER_DETAILS';
export var GET_USER_DETAILS_REQUEST = 'GET_USER_DETAILS_REQUEST';
export var GET_USER_DETAILS_SUCCESS = 'GET_USER_DETAILS_SUCCESS';
export var GET_USER_DETAILS_FAILURE = 'GET_USER_DETAILS_FAILURE'; // -------------------------------------------------
// ACTIONS
// -------------------------------------------------

export var getUserDetails = function getUserDetails() {
  var getWishlist = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return {
    type: GET_USER_DETAILS,
    request: handleRequest('get'),
    getWishlist: getWishlist
  };
};
export var getUserDetailsRequest = function getUserDetailsRequest() {
  return {
    type: GET_USER_DETAILS_REQUEST
  };
};
export var getUserDetailsSuccess = function getUserDetailsSuccess(payload) {
  return {
    type: GET_USER_DETAILS_SUCCESS,
    payload: payload
  };
};
export var getUserDetailsFailure = function getUserDetailsFailure(error) {
  return {
    type: GET_USER_DETAILS_FAILURE,
    error: error
  };
}; // -------------------------------------------------
// REDUCER
// -------------------------------------------------

export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var newState = cloneDeep(state);

  switch (action.type) {
    case GET_USER_DETAILS_REQUEST:
      {
        newState.ui.isRequesting = true;
        return newState;
      }

    case GET_USER_DETAILS_SUCCESS:
      {
        newState.data = action.payload;
        newState.ui.isRequesting = false;
        return newState;
      }

    case GET_USER_DETAILS_FAILURE:
      {
        newState.error = action.error;
        newState.ui.isRequesting = false;
        return newState;
      }

    default:
      {
        return state;
      }
  }
});